// /**
//  * Products - list
//  */

// React
import React, { useState } from 'react'

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper
} from '@material-ui/core'

import RonadIcons from '../../../components/iconComponent'

// Type
type Dimensions = {
  number: number
  size: number
  weight: number
  delete: number
}

type Data = Dimensions
type Props = {
  data: Dimensions[]
  modal?: boolean
  setDimensions: (data: Dimensions[]) => void
  editMode: boolean
}

interface HeadCell {
  id: keyof Data
  label: string
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#d3d6e8 !important',
      color: '#fffff'
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-root': {
        padding: '15px'
      },
      '& .MuiIconButton-sizeSmall': {
        padding: '8px'
      }
    },
    paper: {
      width: '100%'
    },
    columnText: {
      padding: '0 10px'
    },
    dot: {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      left: '-8px',
      width: '8px',
      height: '8px',
      borderRadius: '50%'
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    }
  })
)

const headCells: HeadCell[] = [
  {
    id: 'number',
    label: 'شماره بسته'
  },
  {
    id: 'size',
    label: 'سایز بسته'
  },
  {
    id: 'weight',
    label: 'وزن'
  },
  {
    id: 'delete',
    label: 'حذف'
  }
]

function EnhancedTableHead() {
  const classes = useStyles()
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          return (
            <StyledTableCell
              key={headCell.id}
              align='center'
              data-cy={headCell.id}
            >
              {headCell.id !== 'delete' && (
                <span className={classes.columnText}>{headCell.label}</span>
              )}
            </StyledTableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default function DimensionsCrossdoc(props: Props) {
  const [dense] = useState(true)

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
        '& .MuiTableCell-root': {
          padding: '15px'
        },
        '& .MuiIconButton-sizeSmall': {
          padding: '8px'
        }
      },
      table: {
        minWidth: props.modal ? 500 : 750
      }
    })
  )

  const classes = useStyles()

  const deleteDimension = (id: any) => {
    const updatedDimensions = props.data.filter((row: any) => row.id !== id)
    props.setDimensions(updatedDimensions)
  }

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={dense ? 'small' : 'medium'}
          aria-label='enhanced table'
        >
          <EnhancedTableHead />
          <TableBody>
            {props.data.map((row: any, index: number) => {
              const labelId = `enhanced-table-checkbox-${index}`
              return (
                <TableRow key={index}>
                  <TableCell
                    component='th'
                    id={labelId}
                    scope='row'
                    align='center'
                  >
                    بسته {index + 1}
                  </TableCell>
                  <TableCell
                    component='th'
                    id={labelId}
                    scope='row'
                    align='center'
                  >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <span style={{ marginLeft: '5px' }}>{row?.name}</span>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          direction: 'ltr'
                        }}
                      >
                        ({row?.length} <b>x</b>
                        {row?.width} <b>x</b>
                        {row?.height})
                      </span>
                    </div>
                  </TableCell>

                  <TableCell
                    component='th'
                    id={labelId}
                    scope='row'
                    align='center'
                  >
                    {row.totalWeight}
                  </TableCell>

                  {!props.editMode && (
                    <TableCell
                      component='th'
                      id={labelId}
                      scope='row'
                      align='center'
                    >
                      <IconButton
                        aria-label='cancele'
                        title='حذف آیتم '
                        size='small'
                        onClick={() => deleteDimension(row.id)}
                        data-cy='removeBtn'
                      >
                        <RonadIcons
                          name='times'
                          className='pointer text-danger'
                          // size={0.8}
                        />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
